/**
 * @generated SignedSource<<4888d54022474354248230c95b17f823>>
 * @relayHash 941786e56bf5376678adc8a25f04b07a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 98817cdef3e0bb9472d77cedb7d32efabdbffefe89c61727c387caa12f21d2f7

import type { ConcreteRequest } from 'relay-runtime';
export type CcpPricingType = "EXTERNAL" | "FREE" | "LIMITED_FREE" | "PAID" | "%future added value";
export type useMeetingsQuery$variables = {
  cloudId: string;
  cloudIds: ReadonlyArray<string>;
  siteAri: string;
};
export type useMeetingsQuery$data = {
  readonly loom_connectedCalendars: ReadonlyArray<{
    readonly guid: string;
  } | null> | null;
  readonly loom_meetingsSearch: {
    readonly recurring: ReadonlyArray<{
      readonly id: string;
      readonly inviteeAris: ReadonlyArray<string | null> | null;
      readonly invitees: ReadonlyArray<{
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null> | null;
      readonly recorder: {
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
      readonly recorderId: string | null;
      readonly startsAt: string | null;
      readonly title: string;
      readonly video: {
        readonly id: string;
        readonly isMeeting: boolean | null;
        readonly meetingAri: string | null;
        readonly url: string;
      } | null;
    } | null> | null;
    readonly single: ReadonlyArray<{
      readonly id: string;
      readonly inviteeAris: ReadonlyArray<string | null> | null;
      readonly invitees: ReadonlyArray<{
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null> | null;
      readonly recorder: {
        readonly accountId: string;
        readonly name: string;
        readonly picture: AGG$URL;
      } | null;
      readonly recorderId: string | null;
      readonly startsAt: string | null;
      readonly title: string;
      readonly video: {
        readonly id: string;
        readonly isMeeting: boolean | null;
        readonly meetingAri: string | null;
        readonly url: string;
      } | null;
    } | null> | null;
  } | null;
  readonly loom_settings: {
    readonly meetingNotesAvailable: boolean | null;
    readonly meetingNotesEligible: boolean | null;
    readonly meetingRecordingsAvailable: boolean | null;
  } | null;
  readonly tenantContexts: ReadonlyArray<{
    readonly confluenceEntitlementInfo: {
      readonly entitlement?: {
        readonly offering: {
          readonly pricingType: CcpPricingType | null;
        } | null;
        readonly relatesFromEntitlements: ReadonlyArray<{
          readonly relationshipType: string | null;
        } | null> | null;
      } | null;
    } | null;
    readonly jiraEntitlementInfo: {
      readonly entitlement?: {
        readonly offering: {
          readonly pricingType: CcpPricingType | null;
        } | null;
      } | null;
    } | null;
  } | null> | null;
};
export type useMeetingsQuery = {
  response: useMeetingsQuery$data;
  variables: useMeetingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIds"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudIds",
    "variableName": "cloudIds"
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "confluence.ondemand"
  }
],
v5 = {
  "concreteType": "CcpEntitlementRelationship",
  "kind": "LinkedField",
  "name": "relatesFromEntitlements",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "relationshipType"
    }
  ]
},
v6 = {
  "kind": "ScalarField",
  "name": "pricingType"
},
v7 = {
  "concreteType": "CcpOffering",
  "kind": "LinkedField",
  "name": "offering",
  "plural": false,
  "selections": [
    (v6/*: any*/)
  ]
},
v8 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "jira-software.ondemand"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "cloudId"
  }
],
v10 = {
  "args": (v9/*: any*/),
  "concreteType": "LoomSettings",
  "kind": "LinkedField",
  "name": "loom_settings",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "meetingRecordingsAvailable"
    },
    {
      "kind": "ScalarField",
      "name": "meetingNotesAvailable"
    },
    {
      "kind": "ScalarField",
      "name": "meetingNotesEligible"
    }
  ]
},
v11 = {
  "args": (v9/*: any*/),
  "concreteType": "LoomConnectedCalendar",
  "kind": "LinkedField",
  "name": "loom_connectedCalendars",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "guid"
    }
  ]
},
v12 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "siteAri"
  }
],
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = {
  "kind": "ScalarField",
  "name": "title"
},
v15 = {
  "kind": "ScalarField",
  "name": "startsAt"
},
v16 = {
  "kind": "ScalarField",
  "name": "recorderId"
},
v17 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v18 = {
  "kind": "ScalarField",
  "name": "name"
},
v19 = {
  "kind": "ScalarField",
  "name": "picture"
},
v20 = [
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "inviteeAris"
},
v22 = {
  "concreteType": "LoomVideo",
  "kind": "LinkedField",
  "name": "video",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    {
      "kind": "ScalarField",
      "name": "url"
    },
    {
      "kind": "ScalarField",
      "name": "isMeeting"
    },
    {
      "kind": "ScalarField",
      "name": "meetingAri"
    }
  ]
},
v23 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  {
    "kind": "LinkedField",
    "name": "recorder",
    "plural": false,
    "selections": (v20/*: any*/)
  },
  (v21/*: any*/),
  {
    "kind": "LinkedField",
    "name": "invitees",
    "plural": true,
    "selections": (v20/*: any*/)
  },
  (v22/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v25 = {
  "concreteType": "CcpOffering",
  "kind": "LinkedField",
  "name": "offering",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v13/*: any*/)
  ]
},
v26 = [
  (v24/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v13/*: any*/)
],
v27 = [
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  {
    "kind": "LinkedField",
    "name": "recorder",
    "plural": false,
    "selections": (v26/*: any*/)
  },
  (v21/*: any*/),
  {
    "kind": "LinkedField",
    "name": "invitees",
    "plural": true,
    "selections": (v26/*: any*/)
  },
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useMeetingsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "alias": "confluenceEntitlementInfo",
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v7/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          },
          {
            "alias": "jiraEntitlementInfo",
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
          }
        ]
      },
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "args": (v12/*: any*/),
        "concreteType": "LoomMeetings",
        "kind": "LinkedField",
        "name": "loom_meetingsSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "LoomMeeting",
            "kind": "LinkedField",
            "name": "single",
            "plural": true,
            "selections": (v23/*: any*/)
          },
          {
            "concreteType": "LoomMeeting",
            "kind": "LinkedField",
            "name": "recurring",
            "plural": true,
            "selections": (v23/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useMeetingsQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "alias": "confluenceEntitlementInfo",
            "args": (v4/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v25/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"confluence.ondemand\")"
          },
          {
            "alias": "jiraEntitlementInfo",
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v24/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v13/*: any*/)
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
          }
        ]
      },
      (v10/*: any*/),
      (v11/*: any*/),
      {
        "args": (v12/*: any*/),
        "concreteType": "LoomMeetings",
        "kind": "LinkedField",
        "name": "loom_meetingsSearch",
        "plural": false,
        "selections": [
          {
            "concreteType": "LoomMeeting",
            "kind": "LinkedField",
            "name": "single",
            "plural": true,
            "selections": (v27/*: any*/)
          },
          {
            "concreteType": "LoomMeeting",
            "kind": "LinkedField",
            "name": "recurring",
            "plural": true,
            "selections": (v27/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "941786e56bf5376678adc8a25f04b07a",
    "id": "98817cdef3e0bb9472d77cedb7d32efabdbffefe89c61727c387caa12f21d2f7",
    "metadata": {},
    "name": "useMeetingsQuery",
    "operationKind": "query",
    "text": "query useMeetingsQuery($siteAri:ID!,$cloudId:ID!,$cloudIds:[ID!]!){tenantContexts(cloudIds:$cloudIds){confluenceEntitlementInfo:entitlementInfo(hamsProductKey:\"confluence.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{relatesFromEntitlements{relationshipType},offering{pricingType,id},id}}},jiraEntitlementInfo:entitlementInfo(hamsProductKey:\"jira-software.ondemand\"){__typename,...on CommerceEntitlementInfoCcp{entitlement{offering{pricingType,id},id}}}},loom_settings(siteId:$cloudId){meetingRecordingsAvailable,meetingNotesAvailable,meetingNotesEligible},loom_connectedCalendars(siteId:$cloudId){guid},loom_meetingsSearch(id:$siteAri){single{id,title,startsAt,recorderId,recorder{__typename,accountId,name,picture,id},inviteeAris,invitees{__typename,accountId,name,picture,id},video{id,url,isMeeting,meetingAri}},recurring{id,title,startsAt,recorderId,recorder{__typename,accountId,name,picture,id},inviteeAris,invitees{__typename,accountId,name,picture,id},video{id,url,isMeeting,meetingAri}}}}"
  }
};
})();

(node as any).hash = "8b0fe530992433732be8fc648d702919";

export default node;
